module.exports = __webpack_public_path__ + "static/media/icon_trophy.aafe2e1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_trophy.svg
// module id = 170
// module chunks = 0